import React, { useState, useEffect, useRef, useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import { Rating } from 'react-simple-star-rating';
import ClickOutsideHandler from '../../utility/ClickOutsideHandler';


import WalkingTimeDistance from '../../assets/landing-page/walking-time-distance.svg';
import WalkingTimeDistance2 from '../../assets/landing-page/walking-time-distance-2.png';
import { ReactComponent as MeasureArrow } from '../../assets/landing-page/wwm/arrow.svg';

import GemReport from '../../assets/home-page/report/gem-report2.png';
import FeelReport from '../../assets/home-page/report/feel-report2.jpg';
import Analytics from '../../assets/home-page/report/analytics.png';

import Multisearch from '../../assets/home-page/multisearch.png';

import WRIcon from '../../assets/home-page/wr-icon.png';

import { ReactComponent as Search } from '../../assets/search.svg';
import { ReactComponent as Target } from '../../assets/target.svg';

import RH from '../../assets/client/rh.png';
import CCRNY from '../../assets/client/ccrny.jpg';
import Omega from '../../assets/client/omega.png';

import Banner from '../../assets/home-page/banner.png';

import { ReactComponent as Play } from '../../assets/play-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/cancel-white.svg';

import BannerVideo from '../../assets/home-page/home-video.mp4';
import IntelTabsVideo from '../../assets/home-page/intel-tabs-video.mp4';

import {
  walkIndexFeatures,
  lifeStyleFeatures,
  partnersData,
  otherFeatures,
  impactData,
  neighborhoodIntelTabs,
  neighborhoodSearchFeatures,
  measureSlideData,
  testimonialsData,
} from '../../constants';

import { fetchPlaceDetails } from '../../api';
import { saveAddressToRecentlyViewed, debounce, scrollToTop } from '../../services';

import Slider from 'react-slick';
import Show from '../../utility/Show';

const Home = () => {
  const { state, actions, dispatch, navigate } = useContext(StoreContext);
  const { isGoogleMapsLoaded, currentCity, currentView } = state;
  const [currentTab, setCurrentTab] = useState(0);
  const [measureTab, setMeasureTab] = useState(0);
  const [predictions, setPredictions] = useState([]);
  const [showIframe, setShowIframe] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const inputRef = useRef();
  let sliderRef = useRef(null);
  let measureSliderRef = useRef(null);
  const iframeRef = useRef(null);
  const placeholderRef = useRef(null);

  const gotoContactUs = () => {
    navigate('/contact-us');
    document.title = 'Contact Us - Walkspan';
  };

  const NeighborhoodIntelTabs = () => {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipe: false,
      adaptiveHeight: true,
    };

    const handleTabClick = (index) => {
      setCurrentTab(index);
      // Scroll to the corresponding section/container
      const sectionId = `intel-tab-section-${index}`;
      const section = document.getElementById(sectionId);
      if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    return (
      <>
        <div className="relative h-fit md:h-[100svh] text-white flex p-12">
          <img
            className='banner-placeholder blur-sm'
            src={Banner}
            alt='Loading video...'
          />
          {/* <video muted autoPlay loop playsInline className="absolute top-0 left-0 w-full h-full object-cover -z-10">
            <source src="https://sensofwalk-demo-assets.s3.us-east-2.amazonaws.com/home-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
          <div className="flex flex-col justify-center relative mx-auto gap-8 md:gap-0 [transform:none] md:[transform:translateY(-10%)]">
            <div className='relative text-md md:text-2xl top-0 left-0 w-fit h-auto bg-black bg-opacity-50 p-8 mx-auto z-10'>
              <div>Powered by AI, Walkspan leverages on machine learning </div>
              <div>and location intelligence to reveal the <b>power of place</b></div>
            </div>
            <div className="flex items-center justify-center max-w-screen-2xl">
              <div className="
                grid gap-6
                grid-cols-1
                sm:grid-cols-2
                md:grid-cols-3
                lg:grid-cols-4
                xl:grid-cols-5
                w-full mt-0 md:mt-16
              ">
                {neighborhoodIntelTabs.map((tab, index) => (
                  <div
                    key={index}
                    className="
                      tab h-full min-h-[150px]
                      flex flex-col items-center justify-center md:justify-start gap-2 md:gap-3 cursor-pointer
                      p-3 md:p-6 bg-[#00000080] text-white transition-all duration-300
                      hover:bg-[#1a1a1a] hover:scale-[1.03] hover:shadow-md
                    "
                    onClick={() => handleTabClick(index)}
                  >
                    <div className="text-md md:text-2xl font-bold text-center">{tab.name}</div>
                    <div className="text-sm md:text-xl text-center">{tab.description}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <div className='flex flex-col md:flex-row w-fit justify-between items-center gap-4 md:gap-12 px-4 py-2 m-auto mt-8'>
            <div
              className='req-demo w-auto bg-[#0b1017] p-4 cursor-pointer flex gap-2 items-center min-w-[195px]'
              onClick={() => handleShowVideo()}
            >
              <Play className='!h-[20px] w-auto' /> Watch our video
            </div>

            <div
              className='req-demo w-auto bg-[#0b1017] p-4 cursor-pointer flex gap-2 items-center min-w-[195px] justify-center'
              onClick={() => gotoContactUs()}
            >
              Book a Demo
            </div>
          </div> */}
        </div>
      </>
    );
  };

  const searchAddress = () => {
    if (isGoogleMapsLoaded) {
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();
      if (autocompleteService && inputRef.current) {
        const inputText = inputRef.current.value;
        const city = currentCity ? `${currentCity}, ` : '';

        autocompleteService.getPlacePredictions(
          {
            input: city + inputText,
            types: ['geocode'], // You can specify the types of predictions you want
          },
          async (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
              try {
                // Fetch details for each prediction
                const detailedPredictions = await Promise.all(predictions.map(async (prediction) => {
                  try {
                    const details = await fetchPlaceDetails(prediction.place_id);
                    return {
                      ...prediction,
                      latitude: details.geometry.location.lat(),
                      longitude: details.geometry.location.lng(),
                    };
                  } catch (error) {
                    console.error(`Failed to fetch details for place_id ${prediction.place_id}:`, error);
                    return null;
                  }
                }));

                // Filter out any null results (in case some place details couldn't be fetched)
                const validPredictions = detailedPredictions.filter(prediction => prediction !== null);
                setPredictions(validPredictions);
              } catch (error) {
                console.error('Error fetching place details:', error);
                setPredictions([]);
              }
            } else {
              setPredictions([]);
            }
          }
        );
      }
    }
  };

  const replaceWithDashes = (str) => {
    // Replace non-alphanumeric characters with dashes
    let result = str.replace(/[^a-zA-Z0-9]/g, '-');
    // Replace multiple consecutive dashes with a single dash
    result = result.replace(/-+/g, '-');
    // Remove leading and trailing dashes if any
    result = result.replace(/^-|-$/g, '');
    return result;
  };

  const addressClick = async (address) => {
    // const payload = {
    //   email: 'tmttan03@gmail.com',
    //   password: 'Admin12345+',
    // };
    // await actions.handleLogin(payload);
    // const data = await actions.fetchAddressData(address.description, false, true)

    dispatch({ type: 'SET_IS_ADMIN', payload: true })
    dispatch({ type: 'SET_SHOW_SEARCH_ADDRESS', payload: false });

    //  dispatch({ type: 'SET_CURRENT_ADDRESS', payload: data });

    // saveAddressToRecentlyViewed(data, recentlyViewedAddresses, dispatch);

    window.location.href = `/explore/?address=${address.description}`;
    dispatch({ type: 'SET_LOADING', payload: true });
    // await actions.fetchAddressData(address);
  };

  const handleSearchChange = (event) => {
    if (!event.target.value) {
      setPredictions([]);
    } else {
      searchAddress();
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          actions.handleLogin();
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          actions.fetchAddressByLatLng(lat, lng, true);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowIframe(false);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 } // Adjust this value as needed
    );

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current);
    }

    document.title = 'Home - Walkspan';

    return () => {
      if (placeholderRef.current) {
        observer.unobserve(placeholderRef.current);
      }
    };
  }, []);

  const handleLoadFrame = () => {
    setTimeout(() => {
      setShowIframe(true);
    }, 1000);
  };

  const handleShowVideo = () => {
    setShowVideo(!showVideo);
  };

  const bannerFeatures = [
    {
      title: "Real Estate",
      description: "seamless integration of neighborhood search with property search",
      url: '/services/real-estate'
    },
    {
      title: "Travel",
      description: "displays neighborhood gems in every destination",
      url: '/services/travel'
    },
    {
      title: "20-min city",
      description: "we shrink the city to a 5-10-20 minute walking radii",
      url: '/services/20-min-city'
    },
  ];

  const HomeBanner = () => {
    const gotoContactUs = () => {
      scrollToTop();
      navigate('/contact-us');
      document.title = 'Contact Us - Walkspan';
    };

    return (
      <div className='home-banner'>
        <Show.When isTrue={true}>
          <img
            ref={placeholderRef}
            className='banner-placeholder'
            src={Banner}
            alt='Loading video...'
          />
          {/* <video autoPlay loop muted playsInline className="absolute top-0 left-0 w-full h-full object-cover">
            <source src={BannerVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
        </Show.When>
        <Show.When isTrue={showVideo}>
          <div className="fixed top-0 left-0 w-full !h-[100svh] bg-black bg-opacity-80 flex justify-center items-center z-50">
            <CloseIcon className='absolute top-4 right-4 h-5 w-auto cursor-pointer' />
            <ClickOutsideHandler onOutsideClick={() => handleShowVideo()}>
              <iframe
                width="100%"
                height="auto"
                src="https://player.vimeo.com/video/1058236664?h=b756f18907&badge=0&autopause=0&player_id=0&app_id=58479&byline=0&portrait=0&title=0&ui=0"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="rounded-lg 2xs:w-[80svw] md:w-[100svw] 2xs:h-[25svh] md:h-[50svh]"
              ></iframe>
            </ClickOutsideHandler>
          </div>
        </Show.When>
        <div className='max-w-screen-lg'>
          <div className='banner-content '>
            <div className='text-2xl 2xs:text-xl lg:text-5xl drop-shadow-2xl font-medium mb-14 [text-shadow:0_2px_4px_rgba(0,0,0,0.7)]'>
              NEIGHBORHOOD INTELLIGENCE
            </div>
            <span className='text-2xl [text-shadow:0_2px_4px_rgba(0,0,0,0.7)]'>FIND YOUR NEXT PROPERTY</span>
            <div className='search-address-input'>
              <div
                onClick={() => getLocation()}
                className='current-location-icon'
              >
                <Target />
              </div>
              <input
                ref={inputRef}
                onChange={(e) => handleSearchChange(e)}
                className='!text-black'
                placeholder='Search for an address, location , cities ...'
              />
              <div className='modern-search-address-btn'>
                <Search />
              </div>
              <Show>
                <Show.When isTrue={predictions.length !== 0}>
                  <div
                    className={`prediction-container ${
                      currentView === 'Modern' && 'modern-prediction-container'
                    }`}
                  >
                    {predictions.map((prediction) => (
                      <div
                        className='prediction'
                        key={prediction.place_id}
                        onClick={() => {
                          if (inputRef?.current) {
                            inputRef.current.value = prediction.description;
                          }
                          addressClick(prediction);
                        }}
                      >
                        {prediction.description}
                      </div>
                    ))}
                  </div>
                </Show.When>
              </Show>
            </div>
            {/* <div className='features px-4 py-5 mt-4 2xs:m-4 w-full 2xs:max-w-[365px] md:max-w-[850px]'>
              {bannerFeatures.map((feature) => (
                <a href={feature.url} className='item flex flex-col gap-2 px-5 pl-8 py-5 text-left border-l-2 border-white w-full h-full'>
                  <div className='lg:text-xl text-[16px] font-medium 2xs:pl-2 md:p-0'>{feature.title}</div>
                  <div className='text-[14px] 2xs:pl-2 md:p-0'>{feature.description}</div>
                </a>
              ))}
            </div>
            <div className='flex 2xs:flex-col md:flex-row gap-2'>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black flex gap-2 items-center'
                onClick={() => handleShowVideo()}
              >
                <Play className='!h-[20px] w-auto' /> Watch our video
              </div>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black'
                onClick={() => gotoContactUs()}
              >
                Request a Demo
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  const NeighborhoodSearch = () => {
    return (
      <div className='home-neighborhood-search'>
        <div className='max-w-screen-lg'>
          <div className='title'>neighborhood search</div>
          <div className='ns-features'>
            {neighborhoodSearchFeatures.map((feature, index) => (
              <div>
                <div className='ns-feature-title'>{feature.name}</div>
                <div className='ns-feature-desc'>{feature.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const OtherFeatures = () => {
    return (
      <section className='other-features'>
        <div className='max-w-screen-lg'>
          <h1 className='landing-title'>Other Features</h1>
          <div className='features-list'>
            {otherFeatures.map((feature, index) => (
              <div key={index} className='other-feature-item'>
                <Show>
                  <Show.When isTrue={feature.name === 'Ratings'}>
                    <Rating
                      className='ratings-icon'
                      initialValue={4}
                      iconsCount={5}
                      fillColor='#FFFFFF'
                      readonly
                    />
                  </Show.When>
                  <Show.Else>{feature.img}</Show.Else>
                </Show>
                <p>{feature.name}</p>
              </div>
            ))}
          </div>

          <button className='landing-view-btn'>Explore all features</button>
        </div>
      </section>
    );
  };

  const ImpactStartup = () => {
    return (
      <section className='impact-startup max-w-screen-lg'>
        <h1 className='landing-title'>WALKSPAN IS AN IMPACT STARTUP</h1>
        <div className='description'>
          Our business is designed to solve environmental and societal problems.
          Buying homes where lifestyle essentials are within walking reach will
          generate positive sustainable impacts.
        </div>
        <div className='impact-list'>
          {impactData.map((impact, index) => (
            <div key={index} className='impact-item'>
              <img src={impact.img} alt='Impact' />
              <p>{impact.description}</p>
            </div>
          ))}
        </div>
      </section>
    );
  };

  const Partners = () => {
    return (
      <section className='partners'>
        <div className='max-w-screen-lg'>
          <h1 className='landing-title'>Our Partners</h1>
          <div className='partners-list'>
            {partnersData.map((partner, index) => (
              <div key={index} className='partner-item'>
                <img src={partner.img} alt={partner.name} />
                <h3>{partner.name}</h3>
                <p>{partner.description}</p>
                <a
                  href={partner.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='landing-view-btn'
                >
                  Visit Website
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  const Testimonials = () => {
    return (
      <div className='testimonials-wrapper'>
          <div className='max-w-screen-xl relative'>
            <h1 className='2xs:text-xl md:text-3xl uppercase lg:mb-16 mb-8'>Testimonials</h1>
            <div className='flex 2xs:flex-col md:flex-row gap-12 mb-12'>
              {testimonialsData.map((data, index) => (
                <div className='flex flex-col items-center'>
                  <img src={data.img} alt={`testimonila-${index+1}`} />
                  <div className='mt-2 font-medium text-lg'>{data.name}</div>
                  <div className='font-light mb-6 text-white'>{data.title}</div>
                  <div className='mt-2 2xs:my-2 italic'>“{data.msg}”</div>
                </div>
              ))}
            </div>
            {/* <div className='rounded bg-white text-black w-fit mx-auto py-2 px-6 font-medium cursor-pointer'>
              View all
            </div> */}
          </div>
      </div>
    )
  };

  const SingleInterface = () => {
    return (
      <div className='single-interface' id='intel-tab-section-0'>
        <div className='text-3xl md:text-5xl uppercase'>Single Interface</div>
        <div className='text-lg md:text-xl mb-8'>One-stop solution to exploring the neighborhood</div>
        <div className='text-xl md:text-2xl mb-4'>NEIGBORHOOD SUMMARY DASHBOARD</div>
        <img src={neighborhoodIntelTabs[0].img} alt='Single Interface' />
      </div>
    );
  };

  const Scoring = () => {
    return (
      <div className='scoring' id='intel-tab-section-1'>
        <div className='text-3xl md:text-5xl uppercase'>Scoring</div>
        <div className='text-lg md:text-xl mb-8 max-w-[800px] mx-auto'>
          Scores are based on the presence of lifestyle essentials and sidewalk features, 
          with 3 indicating high presence and 1 indicating little to no presence.
        </div>
        <div className='flex flex-col md:flex-row items-center justify-center gap-4'>
          <img src={neighborhoodIntelTabs[1].img1} alt='Scoring' />
          <img src={neighborhoodIntelTabs[1].img2} alt='Scoring' />
        </div>
      </div>
    );
  };

  const Mapping = () => {

    const Legend = () => {
      return (
         <div className='min-h-[2rem] bg-[#1c293a] w-full flex justify-center items-center text-white text-center py-6'>
          <div className='text-lg'>
            <div className='text-lg text-right mb-2'>Nearness to Listing</div>
            <div className='flex gap-4'>
              <div className='flex flex-col items-center justify-between gap-2'>
                <div className='h-[50px] flex items-center'>Radius</div>
                <div>Distance (mile)</div>
                <div>Time (walking)</div>
              </div>
              <div className='flex flex-col items-center justify-between gap-2'>
                <div className='h-[50px] flex items-center'>
                  <img src={WRIcon} alt='Walkspan Radius Icon' className='!w-[40px] !h-auto rounded-full' />
                </div>
                <div className='text-sm'>0.25</div>
                <div>5</div>
              </div>
              <div className='flex flex-col items-center justify-between gap-2'>
                <div className='h-[50px] flex items-center'>
                  <img src={WRIcon} alt='Walkspan Radius Icon' className='!w-[55px] !h-auto rounded-full' />
                </div>
                <div className='text-sm'>0.5</div>
                <div>15</div>
              </div>
              <div className='flex flex-col items-center justify-between gap-2'>
                <div className='h-[50px] flex items-center'>
                  <img src={WRIcon} alt='Walkspan Radius Icon' className='!w-[65px] !h-auto rounded-full' />
                </div>
                <div className='text-sm'>1</div>
                <div>20</div>
              </div>
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className='mapping' id='intel-tab-section-2'>
        <div className='bg-[#1c293a] text-white pt-16 pb-8'>
          <div className='text-3xl md:text-5xl uppercase'>Mapping</div>
          <div className='text-lg md:text-xl mb-8 mt-2 max-w-[700px] px-8 mx-auto'>
            Sidewalk character is analyzed within a quarter, 
            half, and one-mile radii from each property listing.
          </div>
        </div>
        <div className='w-full py-8'>
          <div className='text-xl md:text-3xl uppercase py-4'>Sidewalk Character</div>
          <div className='flex flex-col md:flex-row items-center justify-center gap-8 pb-4 px-16'>
            {walkIndexFeatures.map((feature, index) => (
              <div key={index} className='mapping-item flex flex-col items-center gap-4 mb-2' style={{ '--icon-color': feature.color }}>
                <img src={feature.mapImg} alt={feature.name} className="!max-w-[150px] md:!max-w-[350px] !h-auto rounded-full" />
                <div className='text-xl'>{feature.name}</div>
                {feature.svg}
              </div>
            ))}
          </div>
        </div>
       {Legend()}

        <div className='bg-[#1c293a] text-white py-8 mt-8'>
          <div className='text-3xl md:text-5xl uppercase'>Mapping</div>
          <div className='max-w-[600px] text-lg md:text-xl px-8 mx-auto'>
            Lifestyle essentials are analyzed within a quarter, 
            half, and one-mile radii from each property listing.
          </div>
        </div>
        <div className='w-full py-8'>
          <div className='text-xl md:text-3xl py-4 uppercase'>Lifestyle essentials</div>
          <div className='flex flex-col md:flex-row items-center justify-center gap-8 pb-4 px-8'>
            {lifeStyleFeatures.slice(1, -1).map((feature, index) => (
              <div
                key={index}
                className='mapping-item flex flex-col items-center gap-4 mb-2'
                style={{ '--icon-color': feature.color}}
              >
                <img src={feature.mapImg} alt='lifestyle-feature' className="!max-w-[150px] md:!max-w-[350px] !h-auto rounded-full" />
                <div className='text-xl'>{feature.name}</div>
                {feature.svg}
              </div>
            ))}
          </div>
        </div>
        {Legend()}
      </div>
    );
  };

  const Reporting = () => {
    return (
      <div className='reporting' id='intel-tab-section-3'>
        <div className='text-3xl md:text-5xl uppercase'>Reporting</div>
        <div className='text-lg md:text-xl mb-8'>Neighborhood insights that complement property reports</div>
        <div className='text-2xl md:text-3xl'>Neighborhood Report</div>
        <div className='text-xl'>565 Broome St, New York, NY 10013, USA</div>
        <div className='flex flex-col md:flex-row gap-4 mt-4 items-center justify-center'>
          <img src={GemReport} alt='Gem Report' className="!max-h-[400px] w-auto !m-0" />
          <img src={FeelReport} alt='Feel Report' className="!max-h-[400px] w-auto !m-0" />
        </div>
        <div className='flex flex-col gap-4 mt-4 items-center justify-center'>
          <div className='text-2xl md:text-3xl mt-4'>Data Analytics</div>
          <div className='text-xl md:text-2xl'>Analytics to uncover what buyers are searching for</div>
          <img src={Analytics} alt='Analytics' className="w-full !max-w-[1050px] h-auto !my-0 mx-auto" />
        </div>
      </div>
    );
  };

  const Recommendation = () => {
    return (
      <div className='recommendation' id='intel-tab-section-4'>
        <div className='text-3xl md:text-5xl uppercase'>Recommendation</div>
        <div className='py-4 text-lg md:text-[22px] text-center max-w-[850px] px-8 mx-auto'>
          <span className='font-medium'>Comparing lifestyle essentials</span> and <span className='font-medium'>sidewalk character</span> across multiple 
          listings increase the likelihood of finding the right property
        </div>
        <img src={neighborhoodIntelTabs[4].img} alt='Recommendation' className="max-w-full h-auto" />
        <div className='mt-16 mb-4'>
          <div className='text-3xl md:text-5xl uppercase'>Recommendation</div>
          <div className='text-lg md:text-[22px] py-4 max-w-[800px] px-8 mx-auto'>
            <span className='font-medium'>Multiple search</span> identify neighborhood must-haves across listings for smarter property choices 
          </div>
          <img src={Multisearch} className='max-w-[1050px] h-auto' alt="Multisearch" />
        </div>
      </div>
    );
  };

  return (
    <div className='landing-home-container'>
      {HomeBanner()}
      {/* {NeighborhoodSearch()} */}
      {NeighborhoodIntelTabs()}
      {SingleInterface()}
      {Scoring()}
      {Mapping()}
      {Reporting()}
      {Recommendation()}

      {/* {Measurements()} */}
      <div className='bg-white py-8 px-10 flex flex-col items-center justify-center'>
        <div className='text-3xl'>CLIENTS</div>
        <div className='flex flex-col md:flex-row gap-8 items-center md:items-end justify-center my-6'>
          <img src={CCRNY} alt='CCRNY' className='!max-w-[250px] h-[100px]' />
          <img src={RH} alt='RH' className='!max-w-[250px] h-[100px]' />
          <img src={Omega} alt='Omega' className='!max-w-[250px] h-[100px]' />
        </div>
      </div>
      {Testimonials()}
      {/* {OtherFeatures()} */}
      {/* <main>
        {ImpactStartup()}
        {Partners()}
      </main> */}
    </div>
  );
};

export default Home;
